import * as React from "react"

import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import Button from '@material-ui/core/Button';
import { withStyles, Theme, WithStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import DialogActions from '@material-ui/core/DialogActions';

import { Trans, WithTranslation, withTranslation } from 'react-i18next';
import { BrowserRouter, Route, Link } from 'react-router-dom';
import { Grid } from "@material-ui/core";

import ResponsiveImgMaterialUi from 'responsive-img-material-ui';

// import CONFIG from '../../cfg/config';

const odstep: string = '          ';

interface FooterProps extends WithTranslation , WithStyles<typeof styles> {
    text: string,
}

class Footer extends React.Component<FooterProps , any> {

    logoClick = () => {
        window.open("http://virtualsc.com.pl/")
    }

  render() {
    const classes = this.props.classes;

    return (
        <div style={{ padding: "25px 0px 15px", maxWidth: "550px", margin: 'auto', alignItems: "center"}} > {/*onClick={this.logoClick}*/} {/*cursor: "pointer"*/}
            <ResponsiveImgMaterialUi style={{ height: "100%", maxHeight: "20px", width: "75%", padding: "6px 12.5%", background: "white", borderRadius: "6px"  }} 
                xs={require('./logo_bookuj.png').default}
                md={require('./logo_bookuj.png').default}
                lg={require('./logo_bookuj.png').default}
            />
      </div>
    );
  }
}

const styles = (theme: Theme) => ({
  
});

export default withTranslation()(withStyles(styles)(Footer));